import { render, staticRenderFns } from "./OrticTable.vue?vue&type=template&id=7c51a424"
import script from "./OrticTable.vue?vue&type=script&lang=js"
export * from "./OrticTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports